import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Settings() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    companyName: 'Hadiye Kılıç Butik',
    phone: '0212 345 67 89',
    address: 'İstanbul, Kadıköy, Moda Caddesi No: 12',
    currency: 'TRY',
    emailNotifications: true,
    smsNotifications: false,
  });

  return (
    <div className="space-y-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-semibold text-boutique-black">{t('settings.title')}</h1>
          <p className="text-sm text-boutique-warm mt-1">İşletme bilgilerini ve tercihleri yönetin</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Company Info */}
        <div className="lg:col-span-2 bg-white rounded-xl border border-cream-200 p-6 space-y-5">
          <h3 className="font-semibold text-boutique-black text-sm">Firma Bilgileri</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-boutique-black mb-2">{t('settings.companyName')}</label>
              <input
                type="text"
                value={formData.companyName}
                onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-cream-200 focus:border-gold-400 focus:ring-2 focus:ring-gold-100 outline-none transition-all text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-boutique-black mb-2">{t('settings.phone')}</label>
              <input
                type="text"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-cream-200 focus:border-gold-400 focus:ring-2 focus:ring-gold-100 outline-none transition-all text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-boutique-black mb-2">{t('settings.address')}</label>
              <textarea
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-cream-200 focus:border-gold-400 focus:ring-2 focus:ring-gold-100 outline-none transition-all text-sm resize-none h-24"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-boutique-black mb-2">{t('settings.currency')}</label>
              <select
                value={formData.currency}
                onChange={(e) => setFormData({ ...formData, currency: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-cream-200 focus:border-gold-400 focus:ring-2 focus:ring-gold-100 outline-none transition-all text-sm bg-white"
              >
                <option value="TRY">TRY - Türk Lirası</option>
                <option value="USD">USD - Amerikan Doları</option>
                <option value="EUR">EUR - Euro</option>
              </select>
            </div>
          </div>
        </div>

        {/* Logo & Notifications */}
        <div className="space-y-6">
          {/* Logo Upload */}
          <div className="bg-white rounded-xl border border-cream-200 p-6">
            <h3 className="font-semibold text-boutique-black text-sm mb-4">{t('settings.logo')}</h3>
            <div className="flex items-center justify-center w-full h-32 bg-cream-50 rounded-xl border-2 border-dashed border-cream-300 cursor-pointer hover:bg-cream-100 transition-colors">
              <div className="text-center">
                <i className="ri-image-line text-3xl text-boutique-warm mb-2" />
                <p className="text-sm text-boutique-warm">{t('settings.uploadLogo')}</p>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="bg-white rounded-xl border border-cream-200 p-6">
            <h3 className="font-semibold text-boutique-black text-sm mb-4">{t('settings.notifications')}</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-500">
                    <i className="ri-mail-line text-lg" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-boutique-black">E-posta Bildirimleri</p>
                    <p className="text-xs text-boutique-warm">Yaklaşan ödemeler ve tahsilatlar</p>
                  </div>
                </div>
                <button
                  onClick={() => setFormData({ ...formData, emailNotifications: !formData.emailNotifications })}
                  className={`w-12 h-6 rounded-full transition-colors relative ${formData.emailNotifications ? 'bg-green-500' : 'bg-cream-300'}`}
                >
                  <span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${formData.emailNotifications ? 'left-7' : 'left-1'}`} />
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center text-green-500">
                    <i className="ri-message-3-line text-lg" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-boutique-black">SMS Bildirimleri</p>
                    <p className="text-xs text-boutique-warm">Gecikmiş ödemeler için</p>
                  </div>
                </div>
                <button
                  onClick={() => setFormData({ ...formData, smsNotifications: !formData.smsNotifications })}
                  className={`w-12 h-6 rounded-full transition-colors relative ${formData.smsNotifications ? 'bg-green-500' : 'bg-cream-300'}`}
                >
                  <span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${formData.smsNotifications ? 'left-7' : 'left-1'}`} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="flex justify-end">
        <button className="inline-flex items-center gap-2 px-6 py-3 bg-boutique-black text-white rounded-lg text-sm font-medium hover:bg-boutique-charcoal transition-colors">
          <i className="ri-save-line" />
          {t('common.save')}
        </button>
      </div>
    </div>
  );
}